module.exports = __webpack_public_path__ + "static/media/chili-piper-example.8b801d51.png";